import { JiraImportPreview } from '@/services/JiraService';

const JIRA_IMPORT_DRAFT_KEY = 'crafter:jira-import-draft';

export interface JiraImportDraft {
  projectKey: string;
  projectName: string;
  epicKey: string;
  epicName: string;
  preview: JiraImportPreview;
  importedAt?: string;
}

export function getJiraImportDraft(): JiraImportDraft | null {
  if (typeof window === 'undefined') return null;

  try {
    const storedDraft = window.sessionStorage.getItem(JIRA_IMPORT_DRAFT_KEY);
    if (!storedDraft) return null;

    const draft = JSON.parse(storedDraft) as Partial<JiraImportDraft>;
    if (
      !draft.projectKey ||
      !draft.projectName ||
      !draft.epicKey ||
      !draft.epicName ||
      !draft.preview
    ) {
      clearJiraImportDraft();
      return null;
    }

    return draft as JiraImportDraft;
  } catch {
    clearJiraImportDraft();
    return null;
  }
}

export function saveJiraImportDraft(draft: JiraImportDraft) {
  if (typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(JIRA_IMPORT_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // Navigation state still carries the draft when storage is unavailable.
  }
}

export function clearJiraImportDraft() {
  if (typeof window === 'undefined') return;

  try {
    window.sessionStorage.removeItem(JIRA_IMPORT_DRAFT_KEY);
  } catch {
    // Storage can be unavailable in restricted browser contexts.
  }
}
